import { IconBrandLinkedin, IconHierarchy2 } from "@tabler/icons-react";
import { Button, Paper, Stack, Text, ThemeIcon, Tooltip } from "@mantine/core";
import { Link, useMatches } from "react-router-dom";
import ListingHandle from "../../lists/ListingWithContent/ListingHandle";
import { useListStore } from "../../../../stores/ListStore";
import { IconEmail } from "../../../../assets/icons/IconEmail";
import { useLanguage } from "../../../../stores/LanguageStore";
import Locked from "../../../../components/View/Locked";

const LeftLinks = () => {
  const lang = useLanguage((s) => s.language);
  const matches = useMatches();
  const minimized = useListStore((s) => s.modelMinimized);
  const setMinimized = useListStore((s) => s.setModelMinimized);

  const elements = {
    email: {
      label: lang.new_senders.email,
      color: "secondary",
      items: [
        {
          label: lang.new_senders.email_accounts,
          link: "/senders/email/",
          icon: <IconEmail />,
        },
        {
          label: lang.new_senders.email_pools,
          link: "/senders/pool/none/email/none",
          icon: <IconHierarchy2 />,
        },
      ],
    },
    linkedin: {
      label: "LinkedIn",
      color: "blue",
      items: [
        {
          label: lang.new_senders.linkedin_accounts,
          link: "/senders/linkedin/",
          icon: <IconBrandLinkedin />,
          lockable: true,
        },
      ],
    },
  };

  const handleClick = ({ isRight }) => {
    setMinimized(!minimized);
  };

  return (
    <Paper
      component={Stack}
      mt={32}
      w={minimized ? 75 : 240}
      px={minimized ? "sm" : "lg"}
      gap={"md"}
      shadow="lg"
      py={16}
      ml={16}
      pos={"relative"}
      radius={0}
      style={{
        transition: "all ease .3s",
        borderRadius: 12,
      }}
      h={400}
      justify="center"
    >
      <Stack gap={64}>
        {minimized
          ? Object.keys(elements).map((key) => {
              let group = elements[key];

              return (
                <Stack key={key} gap={"sm"}>
                  {group.items.map((item) => {
                    let active = matches?.find((x) =>
                      x.pathname.includes(`${item.link}`)
                    );

                    return (
                      <Locked
                        disableLock={key !== "linkedin"}
                        buttonProps={{ size: "sm", radius: "sm" }}
                        top={4}
                        right={-8}
                        key={item?.link}
                        iconOnly
                        withStar
                        starProps={{ size: "sm" }}
                        tooltipProps={{ position: "right" }}
                      >
                        {(isLocked) => (
                          <Tooltip
                            label={item.label}
                            position="right"
                            key={item.link}
                            disabled={isLocked}
                          >
                            <Button
                              component={Link}
                              to={item.link}
                              key={item.link}
                              color={group.color}
                              radius={"md"}
                              h={54}
                              w={isLocked ? 52 : undefined}
                              className="no-shadow"
                              leftSection={
                                <ThemeIcon
                                  variant="filled"
                                  size={"lg"}
                                  color={group.color}
                                  radius={"md"}
                                >
                                  {item.icon}
                                </ThemeIcon>
                              }
                              size="md"
                              variant={active ? "filled" : "subtle"}
                              justify="start"
                              pl={8}
                            >
                              {item.label}
                            </Button>
                          </Tooltip>
                        )}
                      </Locked>
                    );
                  })}
                </Stack>
              );
            })
          : Object.keys(elements).map((key) => {
              let group = elements[key];

              return (
                <Stack key={key} gap={"sm"}>
                  <Text fz={16} fw={600}>
                    {group.label}
                  </Text>

                  {group.items.map((item) => {
                    let active = matches?.find((x) =>
                      x.pathname.includes(`${item.link}`)
                    );

                    return (
                      <Locked
                        disableLock={key !== "linkedin"}
                        buttonProps={{ size: "xs" }}
                        top={-26}
                        right={0}
                        key={item?.link}
                        withStar
                        starProps={{ size: "sm" }}
                        tooltipProps={{ position: "right" }}
                      >
                        {(isLocked) => (
                          <Button
                            component={Link}
                            to={item.link}
                            key={item.link}
                            color={group.color}
                            radius={"md"}
                            h={54}
                            className="no-shadow"
                            leftSection={
                              <ThemeIcon
                                variant="filled"
                                size={"lg"}
                                color={group.color}
                                radius={"md"}
                              >
                                {item.icon}
                              </ThemeIcon>
                            }
                            size="md"
                            variant={active ? "filled" : "subtle"}
                            justify="start"
                            pl={8}
                          >
                            {item.label}
                          </Button>
                        )}
                      </Locked>
                    );
                  })}
                </Stack>
              );
            })}
      </Stack>

      <ListingHandle
        isMinimized={minimized}
        hidden={minimized}
        onClick={handleClick}
        bg="none"
      />
    </Paper>
  );
};

export default LeftLinks;
